import React, { createContext, useState, useContext } from 'react';

const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const updateCategory = (category) => {
    setSelectedCategory(category);
  };
  
  return (
    <CategoryContext.Provider value={{ selectedCategory, updateCategory }}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategory = () => {
    const contextValue = useContext(CategoryContext);
    if (!contextValue) {
        return {};  
      }
    
      return contextValue;
    };